"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Meta = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_instant_1 = require("../Scalar/RTTI_instant");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var RTTI_Coding_1 = require("./RTTI_Coding");
exports.RTTI_Meta = t.recursion('IMeta', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        versionId: RTTI_id_1.RTTI_id,
        _versionId: RTTI_Element_1.RTTI_Element,
        lastUpdated: RTTI_instant_1.RTTI_instant,
        _lastUpdated: RTTI_Element_1.RTTI_Element,
        source: RTTI_uri_1.RTTI_uri,
        _source: RTTI_Element_1.RTTI_Element,
        profile: t.array(RTTI_canonical_1.RTTI_canonical),
        security: t.array(RTTI_Coding_1.RTTI_Coding),
        tag: t.array(RTTI_Coding_1.RTTI_Coding)
    });
});
//# sourceMappingURL=RTTI_Meta.js.map